// Mevcut komutlar listesi
export const AVAILABLE_COMMANDS = [
  'help',
  'contact',
  'about',
  'education',
  'edu',
  'experience',
  'exp',
  'resume',
  'cv',
  'skills',
  'clear',
  'whoami',
  'history',
  'ls',
  'pwd',
  'cd',
  'echo',
  'cat',
];

// Mevcut dizinler listesi
export const AVAILABLE_DIRECTORIES = [
  '~',
  'projects',
  'skills',
  '..',
  '/',
];

// Mevcut dosyalar listesi
export const AVAILABLE_FILES = [
  'about.txt',
  'contact.txt',
  'education.txt',
  'experience.txt',
  'skills.txt',
];

// Autocomplete fonksiyonu
export const getAutocompleteSuggestions = (input: string): string[] => {
  if (!input.trim()) return [];

  const parts = input.trim().split(' ');
  const currentWord = parts[parts.length - 1].toLowerCase();

  // Eğer ilk kelime ise, komutları öner
  if (parts.length === 1) {
    return AVAILABLE_COMMANDS.filter(cmd => 
      cmd.startsWith(currentWord)
    );
  }

  // Eğer cat komutu ise, dosya isimlerini öner
  if (parts[0].toLowerCase() === 'cat' && parts.length === 2) {
    return AVAILABLE_FILES.filter(file => 
      file.toLowerCase().startsWith(currentWord)
    );
  }

  // Eğer cd komutu ise, dizin isimlerini öner
  if (parts[0].toLowerCase() === 'cd' && parts.length === 2) {
    return AVAILABLE_DIRECTORIES.filter(dir => 
      dir.toLowerCase().startsWith(currentWord) || 
      (currentWord === '' && dir !== '..')
    );
  }

  return [];
};

// En iyi eşleşmeyi bul
export const getBestMatch = (input: string): string | null => {
  const suggestions = getAutocompleteSuggestions(input);
  if (suggestions.length === 0) return null;
  
  // Eğer tam eşleşme varsa onu döndür
  const exactMatch = suggestions.find(s => s.toLowerCase() === input.trim().toLowerCase());
  if (exactMatch) return exactMatch;
  
  // İlk öneriyi döndür
  return suggestions[0];
};

